import { render, staticRenderFns } from "./EditInfoCardModal.vue?vue&type=template&id=855374ee&scoped=true&"
import script from "./EditInfoCardModal.vue?vue&type=script&lang=js&"
export * from "./EditInfoCardModal.vue?vue&type=script&lang=js&"
import style0 from "./EditInfoCardModal.vue?vue&type=style&index=0&id=855374ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855374ee",
  null
  
)

export default component.exports